export default __webpack_public_path__ + "static/media/Mark-6-HUD-03.fc2edbee.jpg";